export const verifyMobileRoute = {
  path: '/activation/verify-mobile',
  component: 'activation-verify-mobile',
  componentName: 'Verify Mobile',
  theme: 'lender',
  template: 'activation',
};

export const activationVerifySecondFactorRoute = {
  path: '/activation/verify-second-factor',
  component: 'activation-verify-second-factor',
  componentName: 'Verify Second Factor',
  theme: 'lender',
  template: 'activation',
};

export const activationRoutes = [
  verifyMobileRoute,
  activationVerifySecondFactorRoute,
];



// WEBPACK FOOTER //
// ./components/transaction/src/alias/activationRoutes.js